function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 7.5,
  fill: "#F2F2F2",
  stroke: "#6D0FA7",
  strokeWidth: 3
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 3,
  fill: "#6D0FA7"
});

const SvgDestTransformationActive = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDestTransformationActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dest-transformation-active.c93b02fd.svg";
export { ForwardRef as ReactComponent };